import {
  DocumentData,
  collection,
  doc,
  getDocs,
  updateDoc,
} from "firebase/firestore"

import { db } from "../../firebase"

export async function fetchList(collectionInfo: string[]): Promise<DocumentData[]> {
  const querySnapshot = await getDocs(collection(db, collectionInfo.join("/")))
  return querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
}

export async function updateDocument(collectionInfo: string[], data: DocumentData): Promise<void> {
  if (!data.id) {
    throw new Error("Document ID required for updating")
  }
  try {
    const docRef = doc(db, collectionInfo.join("/"), data.id)
    await updateDoc(docRef, data)
  } catch (error: any) {
    throw new Error(error.message)
  }
}
